import { Dialog, Transition } from '@headlessui/react';
import clsx from 'clsx';
import { Fragment } from 'react';
import Button from './Button';

export default function Modal({ type = 'default', open = false, onClose, className, children }) {
  const typeClasses = {
    default: 'mx-auto w-full max-w-[800px]',
    large: 'mx-auto w-full max-w-[1200px]',
    full: 'absolute inset-0',
  };
  const activeTypeClasses = typeClasses[type];

  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as='div' className='fixed inset-0 !z-[1000] flex' onClose={onClose}>
          <Transition.Child
            as={Fragment}
            enter='transition-opacity ease-linear duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='transition-opacity ease-linear duration-300'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <Dialog.Overlay className='fixed inset-0 bg-black bg-opacity-75' />
          </Transition.Child>

          <div className='fixed inset-0 overflow-y-auto'>
            <div className='flex min-h-full items-center justify-center md:p-4'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
                enterTo='opacity-100 translate-y-0 sm:scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 translate-y-0 sm:scale-100'
                leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
              >
                <Dialog.Panel className={clsx(activeTypeClasses, className)}>
                  <div
                    className={clsx('relative overflow-hidden text-left transition-all transform text-white shadow-lg', {
                      'h-full overflow-y-auto p-4 rounded-none': type === 'full',
                      'sm:my-8 rounded-xl bg-gray-900': type !== 'full',
                    })}
                  >
                    <div className={clsx('absolute z-10 top-3 right-3', type === 'full' ? 'top-8 right-8' : 'top-3 right-3')}>
                      <Button
                        onClick={() => onClose(false)}
                        theme='none'
                        className='flex h-8 w-8 items-center justify-center rounded-full bg-gray-800 hover:bg-black text-white transition duration-250'
                      >
                        <span className='sr-only'>Close modal</span>
                        <svg width={14} height={14} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                          <path
                            d='M8.0009 6.23242L14.1884 0.0449219L15.9559 1.81242L9.7684 7.99992L15.9559 14.1874L14.1884 15.9549L8.0009 9.76742L1.8134 15.9549L0.0458984 14.1874L6.2334 7.99992L0.0458984 1.81242L1.8134 0.0449219L8.0009 6.23242Z'
                            fill={'currentColor'}
                          />
                        </svg>
                      </Button>
                    </div>

                    {type === 'full' ? <div className='bg-gray-900 rounded-xl'>{children}</div> : children}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}
